export default "__VITE_ASSET__51ed1f1b__"